export const subusers = {
  title: "Sub-Usuários",
  subtitle: "Crie e gerencie sub-usuários com acesso aos seus agentes",
  newSubUser: "Novo Sub-Usuário",
  noSubUsers: "Nenhum sub-usuário encontrado",
  edit: "Editar",
  delete: "Excluir",
  name: "Nome",
  email: "Email",
  password: "Senha",
  phone: "Telefone",
  create: "Criar Sub-Usuário",
  table: {
    title: "Nome",
    email: "Email",
    password: "Senha",
    phone: "Telefone",
    actions: "Ações",
  },
  actions: {
    edit: "Editar",
    delete: "Excluir",
  },
  update: "Atualizar",
  invalidEmail: "Email inválido",
  invalidEmailDescription: "Por favor, insira um email válido",
};
